import React from "react";
import { CheckCircle } from "lucide-react";

const TodoHeader = ({ todoStats, t, theme, screenSize }) => {
  return (
    <div
      style={{
        padding: screenSize.isMobile ? "20px" : "24px",
        borderRadius: "18px",
        border:
          theme === "dark"
            ? "2px solid rgba(16, 185, 129, 0.2)"
            : "2px solid rgba(16, 185, 129, 0.15)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-30px",
          right: "-30px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
          opacity: 0.1,
          filter: "blur(40px)",
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircle size={22} color="#fff" strokeWidth={2.5} />
            </div>

            <h4
              style={{
                margin: 0,
                fontSize: screenSize.isMobile ? 20 : 22,
                fontWeight: 800,
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                letterSpacing: "-0.5px",
              }}
            >
              {t.todoList}
            </h4>
          </div>

          <div
            style={{
              width: "100%",
              height: "6px",
              borderRadius: "10px",
              overflow: "hidden",
              marginTop: "12px",
            }}
          >
            <div
              style={{
                width: `${todoStats.progress}%`,
                height: "100%",
                background: "linear-gradient(90deg, #2e7cba, #2e7cba)",
                borderRadius: "10px",
                transition: "width 0.5s ease",
              }}
            />
          </div>

          <p
            style={{
              fontSize: "12px",
              color:
                theme === "dark"
                  ? "rgba(255,255,255,0.6)"
                  : "rgba(0,0,0,0.6)",
              margin: "8px 0 0 0",
              fontWeight: 500,
            }}
          >
            <span style={{ fontWeight: 700, color: "#2e7cba" }}>
              {todoStats.completed}
            </span>{" "}
            {t.of || "من"} {todoStats.total} {t.tasksCompleted || "مكتملة"}
          </p>
        </div>

        <div style={{ position: "relative", width: "70px", height: "70px" }}>
          <svg width="70" height="70" style={{ transform: "rotate(-90deg)" }}>
            <circle
              cx="35"
              cy="35"
              r="30"
              fill="none"
              stroke={
                theme === "dark"
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.08)"
              }
              strokeWidth="6"
            />
            <circle
              cx="35"
              cy="35"
              r="30"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={`${2 * Math.PI * 30}`}
              strokeDashoffset={`${
                2 * Math.PI * 30 * (1 - todoStats.progress / 100)
              }`}
              style={{ transition: "stroke-dashoffset 0.6s ease" }}
            />
            <defs>
              <linearGradient
                id="gradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#2e7cba" />
                <stop offset="100%" stopColor="#2e7cba" />
              </linearGradient>
            </defs>
          </svg>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "16px",
              fontWeight: 900,
              color: "#2e7cba",
            }}
          >
            {todoStats.progress}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodoHeader;
